export const ADO_QUERY_KEYS = {
  dashboard: "adoDashboard",
  throughputByTeam: "adoThroughputByTeam",
  cycleTimeTrend: "adoCycleTimeTrend",
  bugSeveritySplit: "adoBugSeveritySplit",
  testCasesByTeam: "adoTestCasesByTeam",
  featureDeliveryByTeam: "adoFeatureDeliveryByTeam",
  teamDailyCost: "adoTeamDailyCost",
  teamVelocity: "adoTeamVelocity",
  sprintDeliveryCost: "adoSprintDeliveryCost",
  sprints: "adoSprints",
  refreshStatus: "adoRefreshStatus",
  refreshTaskStatus: "adoRefreshTaskStatus",
  refreshHistory: "adoRefreshHistory",
} as const;

export const ADO_METRIC_QUERY_KEYS = [
  ADO_QUERY_KEYS.throughputByTeam,
  ADO_QUERY_KEYS.cycleTimeTrend,
  ADO_QUERY_KEYS.bugSeveritySplit,
  ADO_QUERY_KEYS.testCasesByTeam,
  ADO_QUERY_KEYS.featureDeliveryByTeam,
] as const;

export const adoPriorQueryKey = (root: string): string => `${root}Prior`;

export const ADO_REFRESH_INVALIDATE_KEYS: string[] = [
  ADO_QUERY_KEYS.dashboard,
  ...ADO_METRIC_QUERY_KEYS,
  ...ADO_METRIC_QUERY_KEYS.map(adoPriorQueryKey),
  ADO_QUERY_KEYS.refreshStatus,
  ADO_QUERY_KEYS.refreshHistory,
  ADO_QUERY_KEYS.sprints,
  // Listed on its own rather than in ADO_METRIC_QUERY_KEYS: that list is
  // mirrored into prior-period keys, and this chart has no prior period.
  ADO_QUERY_KEYS.sprintDeliveryCost,
];
